import type { BeneficiaryAccessFetchedAction } from '@Application/Beneficiaries/Access/Actions/beneficiaryAccessFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { BeneficiaryTypeGrantsSavedAction } from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsSaved';
import BeneficiaryAccessView from '@UI/Store/BeneficiaryAccess/Views/BeneficiaryAccessView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type BeneficiaryAccessStore = {
	access: BeneficiaryAccessView | null;
};

const initialState: BeneficiaryAccessStore = {
	access: null,
};

type Actions = BeneficiaryAccessFetchedAction | BeneficiaryTypeGrantsSavedAction | UserRevokedAction;

const whenAccessFetched = (
	_store: BeneficiaryAccessStore,
	action: BeneficiaryAccessFetchedAction,
): BeneficiaryAccessStore => ({
	access: new BeneficiaryAccessView(action.payload),
});

// Saving the grants may change the caller's own level: dropping the cache makes `useBeneficiaryAccess` re-fetch.
const whenAccessStale = (): BeneficiaryAccessStore => initialState;

export default registerStore<'beneficiaryAccessStore', Actions>(
	'beneficiaryAccessStore',
	createSliceReducer({
		BENEFICIARY_ACCESS_FETCHED: whenAccessFetched,
		BENEFICIARY_TYPE_GRANTS_SAVED: whenAccessStale,
		USER_REVOKED: whenAccessStale,
	}),
	initialState,
);
